function noop() {
    /* empty function */
}
function isFunction(
// tslint:disable-next-line
fn
// tslint:disable-next-line
) {
    return typeof fn === "function";
}
export { noop, isFunction };
//# sourceMappingURL=index.js.map